import React from 'react';
import { Form, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { uploadBookingVatFile } from '../../../../services/customer/ticketBookingServices';

function CustomerFileInput({
  className, name, label, errorMessage, rules = [], disabled = false, types, form,
}) {
  const watchFile = Form.useWatch(name, form);
  const beforeUpload = async (file) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
    if (file.size > 50 * 1024 * 1024) {
      form.setFields([
        {
          name,
          errors: ['ფაილის ზომა 50mb-ზე ნაკლები უნდა იყოს'],
        },
      ]);
      return Upload.LIST_IGNORE;
    }
    if (types && !types?.includes(file.type)) {
      form.setFields([
        {
          name,
          errors: ['არასწორი ფაილის ფორმატი'],
        },
      ]);
      return Upload.LIST_IGNORE;
    }
    const formData = new FormData();
    formData.append('file', file);
    const res = await uploadBookingVatFile(formData);
    if (res?.messageText) {
      form.setFieldsValue({
        [name]: {
          name: file.name,
          uid: res?.messageText,

        },
      });
    } else {
      form.setFields([
        {
          name,
          errors: ['ფაილის ატვირთვა ვერ მოხერხდა'],
        },
      ]);
    }
    return Upload.LIST_IGNORE;
  };

  return (
    <Form.Item
      rules={rules}
      className={`customer-input ${className}`}
      name={name}
      label={label}
      help={errorMessage}
      validateStatus={errorMessage && 'error'}
      valuePropName="file"
    >
      <Upload
        beforeUpload={beforeUpload}
        disabled={disabled}
        maxCount={1}
      >
        <div className="flex items-center gap-3">
          <div className="flex justify-center items-center w-12 h-12 rounded-3xl bg-primary cursor-pointer">
            <UploadOutlined style={{
              color: '#fff',
              fontSize: '20px',
            }}
            />
          </div>
          {watchFile?.name}
        </div>
      </Upload>
    </Form.Item>
  );
}

export default CustomerFileInput;
